<template>
  <div class="animated fadeIn list-of-fixedasset">
    <b-card v-if="showList">
      <div slot="header">
        List of Fixed Assets
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Acquisition Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2">PO # &nbsp;</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Asset ID/Number</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.asetid" placeholder="(% for wildcard)" class="mr-2"></b-form-input>
            <b-input-group-prepend>
              <span class="pt-2 mr-1">Asset Name</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.asdesc"
              placeholder="FA Name/Description"
              style="width:40% !important;"
            ></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Group/Category</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2">Depreciation Outstanding &nbsp;</span>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="YesNoAll"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>User | Location</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.asuser" placeholder="User"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCrewShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.aslocat" placeholder="Location" class="ml-2"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuAssetlocatShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Dimension Name</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend>
              <span class="input-group-text">value</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Model/Type/Series</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
            <b-form-input v-model="tblData.asserial" placeholder="Serial Number" class="ml-1"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
        </b-dropdown>
      </template>

        <template v-slot:cell(asdatacq)="data">{{data.item.asdatacq| moment('D-MMM-YY')}}</template>
        <template v-slot:cell(aspurcpri)="data">{{data.item.aspurcpri|numFormat}}</template>
        <template v-slot:cell(nomorpo)="data">
          <router-link :to="{ name: 'procurement.poinvpaymbyponumber', query: {ponumber: data.item.nomorpo}}" target="_blank">{{data.item.nomorpo}}</router-link>
        </template>
        <template v-slot:cell(masa)="data">
          <!-- <span v-if="(data.item.masa)">{{data.item.masa}} months</span> -->
          <span v-if="(data.item.lamathn)">{{data.item.lamathn}} years</span>
          <span v-if="(data.item.lamabln)">{{data.item.lamabln}} months</span>
        </template>
        <template v-slot:cell(asdatuse)="data">
          <span v-if="(data.item.asdatuse)">{{data.item.asdatuse| moment('D-MMM-YY')}}</span>
        </template>
        <template v-slot:cell(tglAkhirDepr)="data">
          <span v-if="(data.item.tglAkhirDepr)">{{data.item.tglAkhirDepr| moment('D-MMM-YY')}}</span>
        </template>
        <template v-slot:cell(Nilaisusut)="data">
          <span v-if="(data.item.deprmethod==1)">{{data.item.Nilaisusut|numFormat('0,0.00')}}</span>
          <span v-else>{{data.item.tarifDD|numFormat('0,0.00')}}% per Year</span>
        </template>
        <template v-slot:cell(Penyusutan)="data">{{data.item.Penyusutan|numFormat('0,0.00')}}</template>
        <template v-slot:cell(NilaiNett)="data">{{data.item.NilaiNett|numFormat('0,0.00')}}</template>
        <template v-slot:cell(aslocat)="data">
          <span v-if="(data.item.namalokasi)">{{data.item.kodelokasi}} | {{data.item.namalokasi}}</span>
          <span v-else>{{data.item.aslocat}}</span>
        </template>
        <template v-slot:cell(asuser)="data">
          <span v-if="(data.item.crewname)">{{data.item.crewnik}} | {{data.item.crewname}}</span>
          <span v-else>{{data.item.asuser}}</span>
        </template>
        <template v-slot:cell(tglgaransi)="data">
          <span v-if="(data.item.txtgaransi)">{{data.item.txtgaransi}} &nbsp;</span>
          <span v-if="(data.item.tglgaransi)">Exp.{{data.item.tglgaransi| moment('D-MMM-YY')}}</span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-1 pr-2">Limit per page</span>
            </b-input-group-prepend>
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width:80px;"
            />
          </b-input-group>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right" v-if="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Are you sure about doing this ?</p>
    </b-modal>
    <b-modal
      v-model="lkuCrewShow"
      size="lg"
      :hide-footer="true"
      title="List of Employee"
      :centered="true"
    >
      <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
    </b-modal>
    <b-modal
      v-model="lkuAssetlocatShow"
      size="lg"
      :hide-footer="true"
      title="List of Location"
      :centered="true"
    >
      <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
    </b-modal>

        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

  </div>
</template>


<style lang="scss">
.list-of-fixedasset {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
 
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuCrew from "../lookup/lkuCrewFull";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import fixedasset from "../../apis/fixedasset";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components: { Loading,lkuCrew, lkuAssetlocat },
  data() {
    return {
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      lkuCrewData:{},
      lkuCrewShow: false,
      lkuAssetlocatShow: false,
      showDelConfirm: false,
      showList: true,
      showForm: false,
      showFilter: false,
      pagination:false,
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "asdatacq",
        sortDesc: true,
        outstand: "",
        catgid: "",
        DimCol: ""
      },
      model: { asetkey: "" },
      YesNoAll: dropdown.YesNoAll,
      categories: []
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "asetid",
          label: "FA Number",
          sortable: true
        },
        {
          key: "asdesc",
          label: "FA Name/Description"
        },
          {
            key: "brand",
            label: "Brand",
            sortable: true
          },
        {
          key: "asmodel",
          label: "Model/Type /Series"
        },
        {
          key: "asdatacq",
          thStyle: "width:80px",
          label: "Acquisition Date",
          sortable: true
        },
        {
          key: "nomorpo",
          label: "Reference Doc.",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "aspurcpri",
          label: "Aquisition Value",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "masa",
          thStyle: "width:80px",
          label: "Depreciation Period",
          sortable: true
        },
        {
          key: "Nilaisusut",
          label: "Monthly Depreciation",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "asdatuse",
          thStyle: "width:80px",
          label: "BeginingDepreciate",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "tglAkhirDepr",
          thStyle: "width:80px",
          label: "Ending Depreciate",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "Penyusutan",
          label: "Accumulate Depreciated",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "NilaiNett",
          label: "Nett Value Asset",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "catgname",
          label: "Category/Group",
          thStyle: "width:200px",
          sortable: true
        },
        {
          key: "aslocat",
          label: "Location",
          thStyle: "width:200px",
          sortable: true
        },
        {
          key: "asuser",
          label: "User",
          thStyle: "width:150px",
          sortable: true
        },
      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
            key: `${dims[i].value}Txt`,
          // thStyle: "width:100px",
          label: dims[i].text,
          sortable: true
        });
      }
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    catgid() {
      return this.tblData.catgid;
    },
    dimCol() {
      return this.tblData.DimCol;
    }
  },
  watch: {
    dimCol: function(newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        d => d.value === newval
      ).text;
    },
    catgid: function(newval) {
      const catg = this.categories.find(c => c.value == newval);
      if (catg) {
        this.tblData.category = catg.text;
      }
    }
  },
  created: async function() {
    const [a] = await Promise.all([fixedasset.category()]);
    this.categories = a.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: "", text: "--- ALL ---" }]
    );
    // this.adjustGroups = b;
  },
  methods: {
    // ischeckedjurnal(val){
    //   const findjv = this.selected.find(x => x === val);
    //   if(findjv){
    //     return 'checked'
    //   }else{
    //     return '';
    //   }
    // },
    // checkedclear() {
    //   this.selected = [];
    //   // uncheck setelah posting selected
    //   const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
    //   checkBoxes.forEach(element => {
    //     element.checked= false;
    //   });
    // },
    // checkedjurnal(item, record) {
    //   this.rowClicked(record);
    //   const asetkey = item.target.attributes["data-asetkey"].value;
    //   // const asetid = item.target.attributes["data-asetid"].value;
    //   if (item.target.checked) {
    //     const findjv = this.selected.find(x => x === asetkey);
    //     if (!(findjv)){
    //       this.selected.push(asetkey);
    //       // this.selectedid.push(asetid);
    //       this.selectedid.push({asetid:record.asetid, childs: record.childs })
    //     }
    //   } else {
    //     const findIdx = this.selected.findIndex(x => x === asetkey);
    //     this.selected.splice(findIdx, 1);
    //     this.selectedid.splice(findIdx, 1);
    //   }
    // },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.fassetList) {
        this.tblData[key] = filter.fassetList[key];
        filtered = true;
      }
      if (filtered === true) {
          this.tblData.tgl1=filter.fassetList.tgl1 || '';
          this.tblData.tgl2=filter.fassetList.tgl2 || '';
        this.showFilter = filtered;
        delete filter.fassetList;
        this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await fixedasset.list(this.tblData);
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await fixedasset.list(this.tblData);
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.catgid = "";
      this.tblData.nomorpo = "";
      this.tblData.outstand = "";
      this.tblData.asetid = "";
      this.tblData.asdesc = "";
      this.tblData.asmodel = "";
      this.tblData.asserial = "";
      this.tblData.asuser = "";
      this.tblData.aslocat = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc',
        "catgid",
        "category",
        "catgname",
        "nomorpo",
        "outstand",
        "asetid",
        "asdesc",
        "asmodel",
        "asserial",
        "asuser",
        "aslocat",
        "tgl1",
        "tgl2",
        "DimCol",
        "DimColInfo",
        "DimVal"
      ];
      let filtered = false;
      const fassetList = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          fassetList[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        fassetList.page = this.tblData.page;
        fassetList.limit = this.tblData.limit;
        fassetList.sortBy = this.tblData.sortBy;
        fassetList.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.fassetList = fassetList;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    add: function(data) {
      this.saveFilter();
      router.push({ name: "fixedasset.form" });
    },
    edit: function() {
      if (this.model.asetkey) {
        this.saveFilter();
        router.push({
          name: "fixedasset.form",
          params: { asetkey: this.model.asetkey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    print: async function()
    {
      if (this.model) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await fixedasset.printAcc(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await fixedasset.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if (this.model.asetkey == record.asetkey) {
      //   console.log("model row click: ", this.model);
      //   this.edit();
      // } else {
        if (this.model && this.model._rowVariant) {
          delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      // }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='acc';
              const response = await fixedasset.exportxls(this.tblData);
              const link = document.createElement('a');
                link.setAttribute('download', 'Fixed_asset_list.xlsx');
              const url = window.URL.createObjectURL(new Blob([response.data]));
              link.href = url;
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },    
    onSelectLkuCrew: function(lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
      // this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
      this.tblData.asuser = lkuData.selected.crewname.trim();
      // this.model.crewkey = lkuData.selected.crewkey;
      // this.model.crewnik = this.model.crewnik;
      // this.model.jabatan = lkuData.selected.jabatan;
      // this.model.departemen = this.model.departemen;
      this.lkuCrewShow = false;
    },
    onSelectLkuAssetlocat: async function(_selected) {
      // this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
      this.tblData.aslocat = _selected.namalokasi.trim();
      // this.model.aslocatkey = _selected.aslocatkey;
      // this.model.kodelokasi = this.model.kodelokasi;
      // this.model.namalokasi = _selected.namalokasi;
      this.lkuAssetlocatShow = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    }
  }
};
</script>
